import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom';
import phoneIcon from "./../../assets/images/phoneAppointmnet.png";
import videoIcon from "./../../assets/images/videoAppointment.png";
import phoneIconHighmark from "./../../assets/images/highmark/phoneAppointmnet.png";
import videoIconHighmark from "./../../assets/images/highmark/videoAppointment.png";
import { useTranslation } from 'react-i18next';
import { useChat } from '../Layout/ChatContext';
import { useSelector } from "react-redux";


const PhoneandvideoAppointment = () => {
  const location = useLocation();
  const selectedType = location.state?.selectedType || "defaultType"; 
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  console.log("Selected Type:", selectedType);
    return <>
    {isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">{t('bookAppointment')}</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t('Back')}
            </span>
          </button>       
          <h2 className="page-heading">{t('bookAppointment')}</h2>
        </div>
      }

    <div className="col-md-6 col-lg-5 mt-md-3 mt-sm-0">
      <Link 
        to={{
          pathname: "/calendar-view",
        }}
        state={{selectedType, appointmentType: "phone", SlotType: `${selectedType}-Phone`}}
        className="phone-video-appointment-wrappr phone-appointment"
      >
        {isHighmarkPortal ? <img src={phoneIconHighmark} alt="" /> : <img src={phoneIcon} alt="" /> }
        <span className="link-wrapper">{t('schedulePhoneConsultation')}</span>
      </Link>      
    </div>
    {/* <div className="col-md-2 mt-md-5 mt-sm-0"></div> */}
    <div className="col-md-6 col-lg-5 ms-auto mt-3 mb-5">
      <Link 
        to={{
          pathname: "/calendar-view",
        }}
        state={{ selectedType, appointmentType: "video", SlotType: `${selectedType}-Video` }}
        className="phone-video-appointment-wrappr video-appointment"
      >
        {isHighmarkPortal ? <img src={videoIconHighmark} alt="" /> : <img src={videoIcon} alt="" /> }
        <span className="link-wrapper">{t('scheduleVideoConsultation')}</span>
      </Link>
    </div>
    {/* <div className="col-md-6 fertility-tracker-right-section">
      right
    </div> */}
    {/* {isChatVisible && <ChatBotWindow />} */}
  </>
  };
  
  export default PhoneandvideoAppointment; 